/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mcp_Servers_Auth_OauthInputs */



/**
* | output |
* | --- |
* | "OAuth (sign in)" |
*
* @param {Mcp_Servers_Auth_OauthInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const mcp_servers_auth_oauth = /** @type {((inputs?: Mcp_Servers_Auth_OauthInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mcp_Servers_Auth_OauthInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("OAuth (Anmeldung)")
	return /** @type {LocalizedString} */ ("OAuth (sign in)")
});